import React from 'react';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormCheckBox from 'components/dashboard/form/SMFormCheckBox';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormTextArea from 'components/dashboard/form/SMFormTextArea';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormCheckBoxWithError from 'components/dashboard/form/SMFormCheckBoxWithError';

class SMConciergeDetailFormView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      concierge: this.props.concierge,
    };
  }

  componentWillMount() {
    const concierge = this.state.concierge;
    concierge.accept_term_of_service = false;
    this.setState({
      concierge: concierge,
    });
  }
  
  componentDidMount() {
    SMTrackHelper.criteoItem(this.props.currentUser ? this.props.currentUser.email : "", "concierge");
  }

  fieldDidChange(e) {
    let name = e.currentTarget.name,
        value = e.currentTarget.value,
        concierge = this.state.concierge;

    if (/concierge\[\w*\]/.test(name)) {
      const start = name.indexOf( "[" );
      const end = name.indexOf( "]" );
      name = name.slice( start+1, end );
    }

    concierge[name] = e.currentTarget.type == 'checkbox' ? e.currentTarget.checked : value;
    this.setState({
      concierge: concierge
    });
  }

  selectBoxDidChangeValue(e) {
    this.fieldDidChange(e);
  }

  textAreaDidEndEditing(e) {
    this.fieldDidChange(e);
  }

  textFieldDidEndEditing(e) {
    this.fieldDidChange(e);
  }

  checkBoxDidChangeValue(e) {
    this.fieldDidChange(e);
  }

  formDidSubmit(e) {
    e.preventDefault();
    let form = this.refs.form,
        formData = new FormData(form),
        queries = {};

    SMOwnerResource.postConcierge(formData, queries, (data, error, xhr) => {
      if (xhr.status == 201) {
        window.location.href = Routes.sent_concierge_index_path({reservation_id: data["reservation"]["id"]});
      } else {
        var errors = xhr.responseJSON.errors;

        this.setState({
          errors: errors
        });
      }
    });
  }

  canSendForm() {
    let concierge = this.state.concierge;
    let canSendForm = concierge.event_type &&
                      concierge.capacity &&
                      concierge.location != 'anywhere' &&
                      concierge.max_budget &&
                      concierge.content &&
                      concierge.family_name &&
                      concierge.given_name &&
                      concierge.email &&
                      concierge.tel &&
                      concierge.postal_code &&
                      concierge.state &&
                      concierge.city &&
                      concierge.address_1 &&
                      concierge.corp_name &&
                      concierge.industry_id &&
                      concierge.job_id &&
                      concierge.accept_term_of_service == true;

    return (!!canSendForm);
  }

  renderError(field) {
    let errorText = SMFormatHelper.errorText('Concierge', field, this.state.errors);

    return(
      <SMFormValidationMessage
        name={field}
        withIcon={true}
        errorText={errorText} />
    );
  }

  generatePullDown(items, default_title) {
    let selectBoxItems = [];

    if (default_title) {
      selectBoxItems.push(
        {value: '', label: default_title}
      );
    }

    for(let i=0; i<items.length; i++) {
      selectBoxItems.push(
        {value: items[i].name, label: items[i].name_text}
      );
    }
    return selectBoxItems;
  }

  renerHiddenForms() {
    let concierge = this.props.concierge;
    const row = [];
    if (concierge.state) {
      row.push(<input type='hidden' key='state' name='state' value={concierge.state} />);
    }
    if (concierge.address_1) {
      row.push(<input type='hidden' key='address_1' name='address_1' value={concierge.address_1} />);
    }
    if (concierge.address_2) {
      row.push(<input type='hidden' key='address_2' name='address_2' value={concierge.address_2} />);
    }
    if (concierge.postal_code) {
      row.push(<input type='hidden' key='postal_code' name='postal_code' value={concierge.postal_code} />);
    }
    if (concierge.fax) {
      row.push(<input type='hidden' key='fax' name='fax' value={concierge.fax} />);
    }
    return (
      <div>
        {row}
      </div>
    );
  }

  render() {
    let submitClassName = "pt13 pb13 w250",
        submitDisabled = true;

    if (this.canSendForm()) {
      submitClassName += " button-blue";
      submitDisabled = false;
    } else {
      submitClassName += " button-disabled";
    }

    return (
      <form ref='form' onSubmit={this.formDidSubmit.bind(this)}>
        <div className="even-col__line clearfix">
          <div className="col-sm-12 col-md-4">
            <h2 className="inquiry-form__title">
              <span className="icon-form icon-form__required">必須</span><span className="inquiry-form__title-text">目的</span>
            </h2>
            <span className="service-select__bg">
              <span className="service-select">
                <SMFormSelectBox
                  name='event_type'
                  items={this.generatePullDown(this.props.eventTypeList, '目的：[例]イベント')}
                  selectedValue={this.state.concierge.event_type}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            {this.renderError('event_type')}
          </div>
          <div className="col-sm-12 col-md-4">
            <h2 className="inquiry-form__title"><span className="icon-form icon-form__required">必須</span><span className="inquiry-form__title-text">人数</span></h2>
            <span className="service-select__bg">
              <span className="service-select">
                <SMFormSelectBox
                  name='capacity'
                  items={this.generatePullDown(this.props.capacityList, '人数：[例]100人')}
                  selectedValue={this.state.concierge.capacity}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            {this.renderError('capacity')}
          </div>
          <div className="col-sm-12 col-md-4">
            <h2 className="inquiry-form__title"><span className="icon-form icon-form__required">必須</span><span className="inquiry-form__title-text">希望エリア</span></h2>
            <span className="service-select__bg">
              <span className="service-select">
                <SMFormSelectBox
                  name='location'
                  items={this.generatePullDown(this.props.areaList, '希望エリア：[例]東京都内')}
                  selectedValue={this.state.concierge.location}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            {this.renderError('location')}
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-sm-12 col-md-4">
            <h2 className="inquiry-form__title">
              <span className="icon-form icon-form__required">必須</span><span className="inquiry-form__title-text">イベントご予算総額</span>
            </h2>
            <SMFormTextField
              name='max_budget'
              options={{className: "form-text servicse-form-text w100pa"}}
              placeholderText="200000"
              delegate={this} />
            {this.renderError('max_budget')}
          </div>
          <div className="col-sm-12 col-md-4">
            <h2 className="inquiry-form__title"><span className="icon-form icon-form__optional">任意</span><span className="inquiry-form__title-text">飲食の有無</span></h2>
            <span className="service-select__bg">
              <span className="service-select">
                <SMFormSelectBox
                  name='has_food'
                  items={this.generatePullDown(this.props.foodSelectList, '指定なし')}
                  selectedValue={this.state.concierge.has_food}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-sm-12">
            <h2 className="inquiry-form__title">
              <span className="icon-form icon-form__optional">任意</span><span className="inquiry-form__title-text">必要備品/設備</span>
            </h2>
            <SMFormCheckBoxWithError
              key='error'
              name='amenity[]'
              errorText={SMFormatHelper.errorText('Concierge', 'amenity', this.props.errors)}
              options={{className: "form-checkbox__s"}}
              items={this.generatePullDown(this.props.AmenityList)}
              delegate={this}
              postHiddenData={false} />
            <SMFormTextArea
              name='necessary_equipments'
              options={{className: "form-text inquiry-header__form-textarea"}}
              placeholderText="マイク3本 (内1本はワイヤレス)、プロジェクター1台、着席80名でスクール形式希望。"
              delegate={this} />
            {this.renderError('necessary_equipments')}
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-sm-12">
            <h2 className="inquiry-form__title">
              <span className="icon-form icon-form__required">必須</span><span className="inquiry-form__title-text">メッセージ、お問い合わせ事項</span>
            </h2>
            <SMFormTextArea
              name='content'
              value={this.state.concierge.content}
              options={{className: "form-text inquiry-header__form-textarea clearfix"}}
              placeholderText="200名規模の会社の設立記念日パーティーをやりたいと思っております。普段とは違った、おしゃれなゲストハウスやクラブなど、社員の思い出に残るような場所で開催したいと思っています。場所は新宿・渋谷・原宿周辺希望です。食事は立食形式で、19:00〜21:00くらいの時間です。"
              delegate={this} />
            {this.renderError('content')}
            <p className="inquiry-form__text mt10">（記入例）<br />・開発合宿を趣向を変えて地方の古民家（インターネット完備）で行いたい。<br />・渋谷周辺エリアで、2週間ほど新商品のポップアップショップを行いたい。<br />・インパクトのある採用イベントを東京、銀座、新橋界隈で行いたい。人数は300人予定。</p>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__required">必須</span>
              <span className="popup-form__title-text">姓名</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name">
              <label>
                <span className="popup-form__label">姓</span>
                  <SMFormTextField
                    value={this.state.concierge.family_name}
                    name='family_name'
                    options={{className: "form-text servicse-form-text"}}
                    placeholderText="姓"
                    delegate={this} />
              </label>
              {this.renderError('family_name')}
            </div>
            <div className="information-name">
              <label>
                <span className="popup-form__label">名</span>
                  <SMFormTextField
                    value={this.state.concierge.given_name}
                    name='given_name'
                    options={{className: "form-text servicse-form-text"}}
                    placeholderText="名"
                    delegate={this} />
              </label>
              {this.renderError('given_name')}
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__required">必須</span>
              <span className="popup-form__title-text">郵便番号</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name sm-information__w100pa">
              <label>
                <span className="popup-form__label">半角数字</span>
                  <SMFormTextField
                    value={this.state.concierge.postal_code}
                    type="postal_code"
                    name='postal_code'
                    options={{className: "form-text servicse-form-text"}}
                    placeholderText="1600003"
                    delegate={this} />
              </label>
              {this.renderError('postal_code')}
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__required">必須</span>
              <span className="popup-form__title-text">都道府県・市区町村</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name">
              <span className="popup-form__label">都道府県</span>
              <span className="service-select__bg">
                <span className="service-select">
                  <SMFormSelectBox
                    name='state'
                    selectedValue={this.state.concierge.state}
                    items={this.generatePullDown(this.props.areaList, '都道府県')}
                    options={{className: "service-select__purpose w100pa"}}
                    delegate={this} />
                </span>
              </span>
              {this.renderError('state')}
            </div>
            <div className="information-name">
              <span className="popup-form__label">市区町村</span>
              <label>
                  <SMFormTextField
                    value={this.state.concierge.city}
                    name='city'
                    options={{className: "form-text servicse-form-text"}}
                    placeholderText="新宿区"
                    delegate={this} />
              </label>
              {this.renderError('city')}
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__required">必須</span>
              <span className="popup-form__title-text">町名・番地</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name sm-information__w100per">
              <label>
                <SMFormTextField
                  value={this.state.concierge.address_1}
                  name='address_1'
                  options={{className: "form-text servicse-form-text"}}
                  placeholderText="西新宿6-15-1"
                  delegate={this} />
              </label>
              {this.renderError('address_1')}
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__optional">任意</span>
              <span className="popup-form__title-text">ビル名・部屋番号</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name sm-information__w100per">
              <label>
                <SMFormTextField
                  value={this.state.concierge.address_2}
                  name='address_2'
                  options={{className: "form-text w100pa"}}
                  placeholderText="セントラルパークタワー ラ・トゥール新宿 608"
                  delegate={this} />
              </label>
              {this.renderError('address_2')}
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__required">必須</span>
              <span className="popup-form__title-text">電話番号</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name sm-information__w100pa">
              <label>
                <span className="popup-form__label">ハイフンなしの半角数字</span>
                  <SMFormTextField
                    value={this.state.concierge.tel}
                    type="tel"
                    name='tel'
                    options={{className: "form-text servicse-form-text"}}
                    placeholderText="電話番号：0363045618"
                    delegate={this} />
              </label>
              {this.renderError('tel')}
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__required">必須</span>
              <span className="popup-form__title-text">法人・団体名</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name sm-information__w100pa">
              <label>
                <SMFormTextField
                  value={this.state.concierge.corp_name}
                  name='corp_name'
                  options={{className: "form-text servicse-form-text"}}
                  placeholderText="法人・団体名"
                  delegate={this} />
              </label>
              {this.renderError('corp_name')}
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__optional">任意</span>
              <span className="popup-form__title-text">部署名・肩書</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name sm-information__w100pa">
              <label>
                <SMFormTextField
                  value={this.state.concierge.department}
                  name='department'
                  options={{className: "form-text servicse-form-text"}}
                  delegate={this} />
              </label>
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix">
          <div className="col-md-3">
            <h2 className="popup-form__title">
              <span className="icon-form icon-form__required">必須</span>
              <span className="popup-form__title-text">業種・職種</span>
            </h2>
          </div>
          <div className="col-md-9">
            <div className="information-name">
              <span className="popup-form__label">業種</span>
              <span className="service-select__bg">
                <span className="service-select">
                  <SMFormSelectBox
                    name='industry_id'
                    selectedValue={this.state.concierge.industry_id}
                    items={this.generatePullDown(this.props.industryList, '業種')}
                    options={{className: "service-select__purpose w100pa"}}
                    delegate={this} />
                </span>
              </span>
              {this.renderError('industry_list')}
            </div>
            <div className="information-name">
              <span className="popup-form__label">職種</span>
              <span className="service-select__bg">
                <span className="service-select">
                  <SMFormSelectBox
                    name='job_id'
                    selectedValue={this.state.concierge.job_id}
                    items={this.generatePullDown(this.props.jobList, '職種')}
                    options={{className: "service-select__purpose w100pa"}}
                    delegate={this} />
                </span>
              </span>
              {this.renderError('job_list')}
            </div>
          </div>
        </div>
        <div className="even-col__line clearfix ta-c">
          <input type='hidden' key={'0-hidden'} name='accept_term_of_service' value='0' />
          <SMFormCheckBox
            value={1}
            id="inquiry-form__footer-checkbox"
            name='accept_term_of_service'
            checked={this.state.concierge.accept_term_of_service}
            delegate={this} />
          <label htmlFor="inquiry-form__footer-checkbox" className="form-checkbox__s mt20">
            <a href="https://spacemarket.com/about/terms_of_space_use" target="_blank" className="a__underline">利用規約</a>に同意する
          </label>
          {this.renderError('accept_term_of_service')}
          <div className="mt10">
            <input type="submit" value="この内容で送信する" className={submitClassName} disabled={submitDisabled} />
          </div>
        </div>
      </form>
    );
  }
}
export default SMConciergeDetailFormView;



// WEBPACK FOOTER //
// ./app/javascript/components/concierge/SMConciergeDetailFormView.jsx